export const scrollToRef = (targetRef, options = {}) => {
    const {
        behavior = 'smooth',
        block = 'center',
        inline = 'nearest',
        borderRadius = '15px',
        boxShadow = '0 0px 10px 4px #50aeb0',
        transition = 'all 1000ms ease-in-out 1000ms',
        timeout = 2000,
    } = options;

    if (!targetRef?.current) return;

    targetRef.current.scrollIntoView({
        behavior,
        block,
        inline,
    });

    targetRef.current.style.borderRadius = borderRadius;
    targetRef.current.style.boxShadow = boxShadow;
    targetRef.current.style.transition = transition;

    window.setTimeout(() => {
        if (targetRef.current) {
            targetRef.current.style.boxShadow = 'none';
        }
    }, timeout);
};

export default scrollToRef;
